<div
  class="turkcell-profile-validator"
  fxLayout="row wrap"
  fxLayoutAlign="space-between start"
  fxLayoutGap="10px"
>
  <!--        -->
  <div class="turkcell-profile-info" fxFlex="34" fxFlex.xs="100" flexLayout="column">

    <div class="profile-name">
      <h3>{{profile.profileName}}</h3>
  </div>

    <!-- Image-->
    <div class="profile-image">
      <img [src]="validationImage" alt="Turkcell profile image" />
    </div>
  </div>

  <!--    -->
  <div class="turkcell-profile-form-section" fxFlex="62" fxFlex.sm="100" fxLayoutAlign="center center">
    <form
      class="turkcell-profile-form"
      [formGroup]="validationFormGroup"
      fxLayout="row"
      fxLayoutGap="10px"
    >
      <ng-container formArrayName="validationFields">
        <!--                -->
        <div
          class="form-group" fxFlex="48" fxFlex.xs="100"
          *ngFor="let group of validationFields?.controls; let i = index"
        >
          <ng-container
            dynamicField
            [fields]="validationFieldConfigs"
            [group]="group"
          ></ng-container>
        </div>
      </ng-container>

      <!--       Submit Button             -->
      <!--            <div class="validate-btn">-->
      <!--                <button mat-flat-button-->
      <!--                        type="button"-->
      <!--                        (click)="onValidateProfile()"-->
      <!--                        [color]="isDiscountApplied ? 'warn':'primary'">-->
      <!--                    {{(isDiscountApplied ? 'shared.labels.discountApplied' : 'shared.labels.apply')|translate}}-->
      <!--                </button>-->
      <!--            </div>-->
    </form>
  </div>
</div>
